import React, { useState } from "react";
import { BiGlobe } from "react-icons/bi";
import Zoom from "react-reveal/Zoom";

import theme, { stack, roundness } from "../../../utils/styles";
import data from "../../../data/contact";

const iconPath = "/img/icons/social/";
const { social } = data;
const links = Object.keys(social);

const ContactFAB = (props) => {
  const { isBreakpoint } = props;

  let hoverInit = {};
  links.map((item) => (hoverInit[item] = false));

  const [hover, setHover] = useState(hoverInit);
  const [expand, setExpand] = useState(isBreakpoint ? false : true);

  return (
    <div style={styles.root}>
      {true ? (
        <Zoom bottom when={expand} duration={500}>
          <div style={styles.card}>
            {links.map((item, index) => (
              <img
                key={index}
                src={iconPath + item + ".png"}
                alt={item}
                style={styles.icon(hover[item])}
                onClick={(e) => window.open(social[item], "_blank")}
                onMouseEnter={(e) => {
                  setHover({ [item]: true });
                }}
                onMouseLeave={(e) => {
                  setHover({ [item]: false });
                }}
              />
            ))}
          </div>
        </Zoom>
      ) : null}
      {!expand || isBreakpoint ? (
        <button style={styles.fabButton} onClick={(e) => setExpand(!expand)}>
          <BiGlobe />
        </button>
      ) : null}
    </div>
  );
};

const buttonSize = 30;
const buttonMargin = 10;

const buttonHeightFocused = buttonSize + buttonMargin;
const containerHeight = (buttonSize + buttonMargin * 2) * links.length;
const containerWidth = buttonSize + buttonMargin * 2;

const styles = {
  root: {
    position: "fixed",
    zIndex: stack.contactFAB,
    right: 15,
    bottom: 15,
    display: "flex",
    flexDirection: "column",
    rowGap: 15,
  },
  card: {
    background: theme.colors.gray1,
    boxShadow: "0px 0px 5px 2px rgb(0,0,0,0.3)",
    borderRadius: roundness.card,

    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",

    height: containerHeight,
    width: containerWidth,
    transition: "ease-in-out 0.3s",
  },
  icon: (hover) => ({
    cursor: "pointer",
    height: hover ? buttonHeightFocused : buttonSize,
    margin: buttonMargin,
    transition: "ease-in-out 0.3s",
  }),
  fabButton: {
    boxShadow: "0px 0px 5px 2px rgb(0,0,0,0.3)",
    padding: 10,
    borderStyle: "none",
    background: theme.colors.gray1,
    borderRadius: "100%",
    width: containerWidth,
    height: containerWidth,
    color: "white",
    cursor: "pointer",
    fontSize: buttonSize,
  },
};

export default ContactFAB;
